<div [height]="30"></div>
<table cols="2" cellspacing="0" cellpadding="0">
    <tr>
        <td>
            <div align="left">
                <div style="display:inline-block;" [width]="35"><button [disabled]="!leftEnabled" [ngClass]="{'inactive_rep_arrow': !leftEnabled }" class="btn rep_arrow_left" (click)="leftEnabled && scrollLeft()" data-testid="left"></button></div>
                <span class="year" data-testid="billingHistoryYear">{{currentYear}}</span>
                <div style="display:inline-block;" [width]="10"></div>
                <div style="display:inline-block;" [width]="35"><button [disabled]="!rightEnabled" [ngClass]="{'inactive_rep_arrow': !rightEnabled }" class="btn rep_arrow_right" (click)="rightEnabled && scrollRight()" data-testid="right"></button></div>
            </div>
        </td>
        <td class="right-ref" width="125">
        </td>
        <td>
            <combo name="subscribtions"
                   labelClass="lab-sb"
                   [autocomplete]="true"
                   [hint]="'CHOOSE_SUBSCRIPTION' | translate"
                   i18n-hint
                   #subscriptionsCombo
                   [ComboData]="subscribtions"
                   [(ngModel)]="subscriptionId"
                   (changeCaller)="onSubscriptionChanged($event)"
                   label=""
                   [height]="38"
                   [width]="250"
                   testId="subscriptionsCombo">
            </combo>
        </td>
    </tr>
</table>

<table cols="2" cellspacing="0" cellpadding="0">
    <ng-template ngFor let-order [ngForOf]="orders" let-i="index">
        <tr *ngIf="i==0" class="line"><td colspan="2"></td><td></td><td></td></tr>
        <tr class="row">
            <td class="left-text" data-testid="SubcriptionType">{{order.Fee}} {{order.Type}}</td>
            <td class="right-ref">
                {{order.Date}}
            </td>
            <td class="right-ref">
                <div class="space download-button"
                     (click)="DownloadInvoice(order.OrderRef)" 
                     [tooltip]="this.downloadDocumentText | translate" 
                     data-testid="downloadButton">
                </div>
            </td>
        </tr>
        <tr class="line"><td colspan="2"></td><td></td><td></td></tr>
    </ng-template>
</table>
<div [height]="30"></div>
